import { BetaChartCard } from 'src/pages/reports/components/beta-charts';
import { BetaChartAreaSkeleton } from 'src/pages/reports/components/beta-charts/beta-chart-skeletons';
import { formatCompactNumber, formatPlatformDisplayName } from './overview-beta-format';

export interface SpendSegment {
  name: string;
  value: number;
  colour: string;
}

interface OverviewBetaSpendSegmentsProps {
  segments: SpendSegment[];
  isLoading?: boolean;
}

export function OverviewBetaSpendSegments({
  segments,
  isLoading = false,
}: OverviewBetaSpendSegmentsProps) {
  const total = segments.reduce((sum, segment) => sum + segment.value, 0);

  return (
    <BetaChartCard
      title="Spend Distribution by Platform"
      subtitle={segments.map((segment) => formatPlatformDisplayName(segment.name)).join(' · ') || 'No platforms'}
    >
      {isLoading ? (
        <BetaChartAreaSkeleton className="h-[140px]" />
      ) : segments.length === 0 || total === 0 ? (
        <div className="flex h-[100px] items-center justify-center text-sm text-[#8A8EA0]">
          No spend distribution for the selected period.
        </div>
      ) : (
        <div className="space-y-4">
          {segments.map((segment) => {
            const pct = total > 0 ? (segment.value / total) * 100 : 0;
            return (
              <div key={segment.name}>
                <div className="mb-1.5 flex items-baseline justify-between">
                  <span className="text-[13px] font-semibold capitalize text-[#0D0F1A]">
                    {formatPlatformDisplayName(segment.name)}
                  </span>
                  <span className="font-mono text-xs font-semibold text-[#5E6278]">
                    {formatCompactNumber(segment.value, { currency: true })}
                    {' '}
                    ·
                    {pct.toFixed(1)}
                    %
                  </span>
                </div>
                <div className="flex h-2 overflow-hidden rounded bg-[#EDEEF2]">
                  <div
                    className="h-full transition-[width] duration-500"
                    style={{ width: `${pct}%`, backgroundColor: segment.colour }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </BetaChartCard>
  );
}
